import React from 'react';

import cn from '~/utils/cn';

export type size = 'sm' | 'md' | 'lg';

interface LoadingDotsProps {
  className?: string;
  color?: string;
  size?: size;
}

const sizeClasses: Record<size, string> = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
};

const gapClasses: Record<size, string> = {
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-8',
};

const LoadingDots: React.FC<LoadingDotsProps> = ({ className = '', color = 'bg-blue-500', size = 'md' }) => {
  const dotClass = 'rounded-full animate-pulse  [animation-duration:1.2s]';

  return (
    <div className={cn('flex items-center justify-center', gapClasses[size], className)}>
      <div className={cn(dotClass, sizeClasses[size], color, '[animation-delay:0s]')} />
      <div className={cn(dotClass, sizeClasses[size], color, '[animation-delay:200ms]')} />
      <div className={cn(dotClass, sizeClasses[size], color, '[animation-delay:400ms]')} />
    </div>
  );
};

export default LoadingDots;
